import type { FaireProductEntity } from "../../entity_types/product";

export const p_ty89y623ku: FaireProductEntity = {
  token: "p_ty89y623ku",
  type: "product",
  name: "LM-PEN-CA White Camo Ink Pen",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/efb3d7464b6a57143f3dd07232be4f6ae62c1f73fdfda65ccf5e5598c838b9b4.jpeg",
  galleryImageUrls: [],
  priceDollars: 2,
  description: "This white camo ink pen offers reliable performance with a look that complements any desk or notebook. Designed for smooth writing, it pairs functionality with an aesthetic suited for home, school, or office tasks. Girlie Girl Originals presents a dependable writing tool for routine use.",
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:29.159Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
